import { createRouter, createWebHistory } from 'vue-router';
import BasePath from '@/router/module/basePath';
import BoardPath from '@/router/module/boardPath';
import { notRegisteredRoutePath, sessionInvalidateCheck, tokenCheck } from '@/router/navigationGuard';
import CountryPath from '@/router/module/CountryPath';
import BannerPath from '@/router/module/BannerPath';
import PushPath from '@/router/module/PushPath';
import HistoryPath from '@/router/module/HistoryPath';
import InquiryPath from '@/router/module/InquiryPath';
import { useInquiryStore } from '@/store/modules/inquiry/inquiry';
import BreastPumpPath from '@/router/module/BreastPumpPath';
import DashboardPath from '@/router/module/dashboardPath';
import UserPath from '@/router/module/UserPath';

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  ...BasePath,
  ...BoardPath,
  ...CountryPath,
  ...BannerPath,
  ...PushPath,
  ...HistoryPath,
  ...InquiryPath,
  ...BreastPumpPath,
  ...DashboardPath,
  ...UserPath
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: 'active'
});

router.beforeEach(async (to, from, next) => {
  if (
    !tokenCheck(to, from, next) &&
    !sessionInvalidateCheck(to, from, next) &&
    !notRegisteredRoutePath(to, from, next)
  ) {
    next('/login');
  } else {
    if (['/', '/login'].includes(to.path)) {
      return next();
    }
    const inquiryStore = useInquiryStore();
    await inquiryStore.adminRead();
    next();
  }
});

export default router;